import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '../cn.ts'

export interface ListRowProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  leading?: ReactNode
  title: ReactNode
  subtitle?: ReactNode
  trailing?: ReactNode
  active?: boolean
}

export function ListRow({ leading, title, subtitle, trailing, active, className, ...rest }: ListRowProps) {
  return (
    <div
      className={cn(
        'flex min-h-10 items-center gap-3 rounded-tile px-3 py-2 transition-colors duration-150 ease-out',
        active ? 'bg-pop-tint text-pop-fg' : 'hover:bg-grey-1',
        className,
      )}
      {...rest}
    >
      {leading && <span className="flex shrink-0 text-meta">{leading}</span>}
      <span className="min-w-0 flex-1">
        <span className="block truncate text-[14px] text-text-1">{title}</span>
        {subtitle && <span className="block truncate text-[12px] text-meta">{subtitle}</span>}
      </span>
      {trailing && <span className="shrink-0">{trailing}</span>}
    </div>
  )
}
